<template>
    <tg-dialog
        ref="dialog"
        v-bind="{ ...$attrs }"
        v-on="$listeners"
        :showFooter="false"
        :showCancelBtn="false"
        class="saba-parlay-matches"
        width="70%"
        append-to-body
        :visible.sync="visible"
        :showIcon="false"
        @opened="handleOpen"
        :title="title"
    >
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            :show-header="false"
        >
            <template slot="competition" slot-scope="scope">
                <span :class="{
                    'text-saba': scope.row.content_type != 29,
                    'text-ia_esport': scope.row.content_type == 29
                }"> 
                    {{ scope.row["sport_name"] }} 
                </span>
                <br />
                <span> [{{ scope.row["competition"] }}] </span>
            </template>

            <template slot="event" slot-scope="scope">
                <el-row type="flex" justify="start" align="left" gutter="2">
                    <span class="ma-r-2"
                        ><i class="tg-icon tg-icon-grayball"></i
                        >{{ scope.row["team1"] }}</span
                    >
                    <span
                        ><i class="tg-icon tg-icon-grayball"></i
                        >{{ scope.row["team2"] }}</span
                    ><br />
                </el-row>

                <el-row type="flex" justify="start" align="left" gutter="2">
                    <i class="tg-icon tg-icon-game"></i>

                    <span v-if="scope.row['profit_type_name']" class="text-green"
                        >{{ scope.row["market"] }} {{ scope.row["selection"] }}
                        {{ scope.row["profit_type_name"] }}
                    </span>

                    <span v-else class="text-green"
                        >{{ scope.row["market"] }} {{ scope.row["selection"] }}
                        {{ scope.row["marketType"] }}
                    </span>

                    <span class="mb-1">@</span>
                    <span
                        v-if="scope.row['source_type'] == 'saba' || scope.row['source_type'] == 'sabawhite_sport'"
                        class="text-red"
                        >{{ scope.row["profit"] | floatFilter_2 }}</span
                    >
                    <span v-else class="text-red"
                        >{{ scope.row["odds"] | floatFilter_2 }}%</span
                    >
                </el-row>
            </template>
        </tg-table>
    </tg-dialog>
</template>

<script>
import TgTable from "@/components/table/TgTable";
import TgDialog from "@/components/dialog/TgDialog";

import apis from "@/apis";
var api = apis.third_party.public_sport.detail;

export default {
    inheritAttrs: false,
    components: {
        TgDialog,
        TgTable,
    },
    provide() {
        return {
            container: this.$el,
        };
    },
    data() {
        return {
            columns: [],
            proxy: api.getData,
            visible: false,
            searchData: {},
        };
    },
    created() {},
    computed: {
        title() {
            return this.$t("column.parlay_detail");
        },
    },
    methods: {
        handleOpen() {
            if (this.$refs.table) {
                this.$refs.table.init(this.searchData);
            }
        },
        showDialogForPublic(request) {
            api = apis.third_party.public_sport.detail;
            this.proxy = api.getData;
            api.getColumns().then((response) => {
                this.columns = response.data;
                this.visible = true;
                this.searchData = request;
            });
        },
    },
    filters: {
        floatFilter_2(value) {
            let newVal = "";
            if (!isNaN(value) && value != "") {
                newVal = parseFloat(value).toFixed(2);
            }
            return newVal;
        },
    },
};
</script>
